import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  data: any;
}

const ClassBasicInfo: FC<IProps> = ({
  data,
}) => {
  const { t, i18n } = useTranslation();
  //console.log("dataInfo", data);
  return (
    <>
      <div className="comm-bx__between">
        <h3 className='sub-title'>{t('class.class.title2')}</h3>
      </div>
      <div className='comm-table__area rowType edit'>
        <table>
          <colgroup>
            <col width="25%" />
            <col width="25%" />
            <col width="25%" />
            <col width="25%" />
          </colgroup>
          <tbody>
            <tr>
              <th>{t('class.class.column10')}</th>
              <td>
                {data?.className}{' '}
                ({data?.classStatus === 'OP' ? t('class.class.text5') : t('class.class.column9')})
              </td>
              <th>{t('class.class.column26')}</th>
              <td>{getCommonCodeLabel('PR0002', data?.semesterType, i18n.language) + ' (' + data?.semesterName + ')'}</td>
            </tr>
            <tr>
              <th>{t('class.class.column19')}</th>
              <td colSpan={3}>
                {data?.teacherKoreaName}
              </td>
            </tr>
            <tr>
              <th>{t('common.label.1')}</th>
              <td>
                {getCommonCodeLabel('PR0006', data?.eduStepCode, i18n.language)}
              </td>
              <th>{t('class.class.column11')}</th>
              <td>
                {data?.courseDetailName}
              </td>
            </tr>
            <tr>
              <th>{t('class.class.column12')}</th>
              <td>
                {data?.courseName}
              </td>
              <th>{t('payment.coupon.column15')}</th>
              <td>
                {data?.courseSubName}
              </td>
            </tr>
            <tr>
              <th>{t('class.class.column14')}</th>
              <td>
                {data?.lessonTime} {t('class.class.text7')}
              </td>
              <th>{t('class.class.column15')}</th>
              <td>
                {data?.dayLessonCount} {t('class.class.text8')}
              </td>
            </tr>
            <tr>
              <th>{t('class.class.column16')}</th>
              <td>
                {data?.weekLectureCount} {t('class.class.text2')}
              </td>
              <th>{t('class.class.column17')}</th>
              <td>
                {data?.minPrice?.toLocaleString() || 0} {t('class.class.text6')}
              </td>
            </tr>
            <tr>
              <th>{t('student.student.column113')}</th>
              <td>
                {data?.onlineTuition?.toLocaleString() || 0} {t('class.class.text6')}
              </td>
              <th>{t('payment.charge.option4')}</th>
              <td>
                {data?.alexTuition?.toLocaleString() || 0} {t('class.class.text6')}
              </td>
            </tr>
            {data?.semesterType === "SC" &&
              <tr>
                <th>{t('class.class.column111')}</th>
                <td colSpan={3} className="text-align-left">
                  <div className="flex comm-gap justify-content-start" style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                    {t("class.class.column4") + " : " + data?.classSrtDate + " ~ " + t("class.class.column5") + " : " + data?.classEndDate}
                    
                    <div>{t('class.class.column112') + " : " + data?.tuition.length }</div>
                  </div>
                </td>
              </tr>
            }
            {
              data?.tuition.map((item: any, index: number) => {
                return (
                  <tr>
                    {
                      index === 0 && (<th rowSpan={data?.tuition?.length}>{t('payment.charge.option2')}</th>)
                    }
                    <td colSpan={3}>
                      <div className="flex">
                        <div className="px-2">
                          {t('class.class.text1')} ({item?.lessonCount}{t('class.class.text2')})
                        </div>
                        {data?.semesterType === "SC" &&
                          <div className='flex'>
                            <div className='px-2'>{i18n.language === 'ko' ? item.monthCode + t('class.class.text26') : t('class.class.text26') + ' ' + item.monthCode}</div>
                            <div className='px-2'>{item?.startDate+ ' ~ ' + item?.endDate}</div>
                          </div>
                        }
                        <div>
                          {item?.tuition?.toLocaleString() || 0}{t('class.class.text6')}
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ClassBasicInfo;
